import {
  requestNafath
} from "./chunk-2THTUX6I.mjs";

// src/hooks/wbk/nafath/send.ts
import { useMutation } from "@tanstack/react-query";
var useRequestNafath = () => {
  return useMutation({
    mutationFn: requestNafath
  });
};

export {
  useRequestNafath
};
//# sourceMappingURL=chunk-PC7UAMXT.mjs.map